if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('disabled');
        } else {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('disabled');
        }

        if (this.submitButtonText && text) {
          this.submitButtonText.textContent = text;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Capture product info from page for fallback
        const productTitleEl = document.querySelector('h1.product__title') || document.querySelector('.product-form__title');
        const productImageEl = document.querySelector('.product__media img') || document.querySelector('.product-form__image img');

        const lastAddedProduct = {
          title: productTitleEl ? productTitleEl.textContent.trim() : 'Product',
          variant: this.form.querySelector('[name="id"] option:checked')?.textContent || '',
          image: productImageEl ? productImageEl.src : '',
        };

        if (this.cart && this.cart.tagName === 'CART-NOTIFICATION') {
          this.cart.setLastAddedProduct(lastAddedProduct);

          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        // First, add product to cart
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description || 'Error adding product');
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
              .then((res) => res.json())
              .then((cartData) => {
                if (cartData.items && cartData.items.length) {
                  const addedVariantId = formData.get('id');
                  const lastItem = cartData.items.find(
                    (item) => String(item.variant_id) === String(addedVariantId)
                  ) || cartData.items[cartData.items.length - 1];
                  this.cart.lastAddedProduct = {
                    title: lastItem.product_title,
                    variant: lastItem.variant_title,
                    sellingPlan: lastItem.selling_plan_allocation ? lastItem.selling_plan_allocation.selling_plan.name : '',
                    image: lastItem.image || lastAddedProduct.image,
                  };
                }
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener(
                    'modalClosed',
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(cartData);
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  this.cart.renderContents(cartData);
                }
              });
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }
    }
  );
}
